module.exports = __webpack_public_path__ + "img/norcott_b3.1d8fb9c2.jpg";